"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safetyLinksData = exports.servicesLinksData = exports.legalLinksData = exports.securityLinksData = exports.resourcesLinksData = exports.lifestyleLinksData = exports.topWagCitiesLinksData = exports.aboutWagLinksData = exports.wagTagLinksData = exports.loginLinkData = exports.becomeAWalkerLinkData = exports.dailyWagLinkData = exports.helpCenterLinkData = exports.appStoreLinkData = exports.googlePlayLinkData = exports.homeLinkData = exports.URL_WAG_TAG = exports.URL_TRUST_SAFETY = exports.URL_TRAINING = exports.URL_TERMS_CONDITIONS = exports.URL_SERVICE_DOG_WALKING = exports.URL_SERVICE_DOG_SITTING = exports.URL_SERVICE_DOG_DAYCARE = exports.URL_SERVICE_DOG_BOARDING = exports.URL_SENSES = exports.URL_RESPONSIBLE_DISCLOSURE = exports.URL_PRIVACY_POLICY = exports.URL_PRESS_RELEASES = exports.URL_PARTNERS = exports.URL_NAMES = exports.URL_LIFESTYLE_TRAILS = exports.URL_LIFESTYLE_PARKS = exports.URL_LIFESTYLE_CAMPGROUNDS = exports.URL_LIFESTYLE_BEACHES = exports.URL_HELP_CENTER = exports.URL_GROOMING = exports.URL_GOOGLE_PLAY_APP = exports.URL_DOG_WALKING_ALL = exports.URL_DOG_WALKING_PHILADELPHIA = exports.URL_DOG_WALKING_MIAMI = exports.URL_DOG_WALKING_DALLAS = exports.URL_DOG_WALKING_WASHINGTON = exports.URL_DOG_WALKING_ATLANTA = exports.URL_DOG_WALKING_NEW_YORK = exports.URL_DOG_WALKING_CHICAGO = exports.URL_DOG_WALKING_LOS_ANGELES = exports.URL_DOG_WALKING_SAN_FRANCISCO = exports.URL_DOG_BOARDING_ALL = exports.URL_DAILY_WAG = exports.URL_COMMUNITY_GUIDELINES = exports.URL_CAREERS = exports.URL_CARE = exports.URL_BREEDS = exports.URL_BEHAVIOR = exports.URL_BECOME_WALKER = exports.URL_APP_STORE_APP = exports.URL_APP_LOGIN = exports.URL_ACTIVITIES = exports.URL_ABOUT = exports.URL_HOME = void 0;
var URL_HOME = 'https://wagwalking.com';
exports.URL_HOME = URL_HOME;
var URL_ABOUT = 'https://wagwalking.com/about';
exports.URL_ABOUT = URL_ABOUT;
var URL_ACTIVITIES = 'https://wagwalking.com/activities';
exports.URL_ACTIVITIES = URL_ACTIVITIES;
var URL_APP_LOGIN = 'https://app.wagwalking.com/login';
exports.URL_APP_LOGIN = URL_APP_LOGIN;
var URL_APP_STORE_APP = 'https://wagwalking.com/download/ios?campaign=footer';
exports.URL_APP_STORE_APP = URL_APP_STORE_APP;
var URL_BECOME_WALKER = 'https://wagwalking.com/dog-walker';
exports.URL_BECOME_WALKER = URL_BECOME_WALKER;
var URL_BEHAVIOR = 'https://wagwalking.com/daily/behavior';
exports.URL_BEHAVIOR = URL_BEHAVIOR;
var URL_BREEDS = 'https://wagwalking.com/breed';
exports.URL_BREEDS = URL_BREEDS;
var URL_CARE = 'https://wagwalking.com/care';
exports.URL_CARE = URL_CARE;
var URL_CAREERS = 'https://wagwalking.com/careers';
exports.URL_CAREERS = URL_CAREERS;
var URL_COMMUNITY_GUIDELINES = 'https://wagwalking.com/community-guidelines';
exports.URL_COMMUNITY_GUIDELINES = URL_COMMUNITY_GUIDELINES;
var URL_DAILY_WAG = 'https://wagwalking.com/daily';
exports.URL_DAILY_WAG = URL_DAILY_WAG;
var URL_DOG_BOARDING_ALL = 'https://wagwalking.com/dog-boarding/cities';
exports.URL_DOG_BOARDING_ALL = URL_DOG_BOARDING_ALL;
var URL_DOG_WALKING_SAN_FRANCISCO = 'https://wagwalking.com/dog-walking/ca-san-francisco';
exports.URL_DOG_WALKING_SAN_FRANCISCO = URL_DOG_WALKING_SAN_FRANCISCO;
var URL_DOG_WALKING_LOS_ANGELES = 'https://wagwalking.com/dog-walking/ca-los-angeles';
exports.URL_DOG_WALKING_LOS_ANGELES = URL_DOG_WALKING_LOS_ANGELES;
var URL_DOG_WALKING_CHICAGO = 'https://wagwalking.com/dog-walking/il-chicago';
exports.URL_DOG_WALKING_CHICAGO = URL_DOG_WALKING_CHICAGO;
var URL_DOG_WALKING_NEW_YORK = 'https://wagwalking.com/dog-walking/ny-new-york';
exports.URL_DOG_WALKING_NEW_YORK = URL_DOG_WALKING_NEW_YORK;
var URL_DOG_WALKING_ATLANTA = 'https://wagwalking.com/dog-walking/ga-atlanta';
exports.URL_DOG_WALKING_ATLANTA = URL_DOG_WALKING_ATLANTA;
var URL_DOG_WALKING_WASHINGTON = 'https://wagwalking.com/dog-walking/dc-washington';
exports.URL_DOG_WALKING_WASHINGTON = URL_DOG_WALKING_WASHINGTON;
var URL_DOG_WALKING_DALLAS = 'https://wagwalking.com/dog-walking/tx-dallas';
exports.URL_DOG_WALKING_DALLAS = URL_DOG_WALKING_DALLAS;
var URL_DOG_WALKING_MIAMI = 'https://wagwalking.com/dog-walking/fl-miami';
exports.URL_DOG_WALKING_MIAMI = URL_DOG_WALKING_MIAMI;
var URL_DOG_WALKING_PHILADELPHIA = 'https://wagwalking.com/dog-walking/pa-philadelphia';
exports.URL_DOG_WALKING_PHILADELPHIA = URL_DOG_WALKING_PHILADELPHIA;
var URL_DOG_WALKING_ALL = 'https://wagwalking.com/dog-walking/cities';
exports.URL_DOG_WALKING_ALL = URL_DOG_WALKING_ALL;
var URL_GOOGLE_PLAY_APP = 'https://wagwalking.com/download/android?campaign=footer';
exports.URL_GOOGLE_PLAY_APP = URL_GOOGLE_PLAY_APP;
var URL_GROOMING = 'https://wagwalking.com/grooming';
exports.URL_GROOMING = URL_GROOMING;
var URL_HELP_CENTER = 'https://help.wagwalking.com';
exports.URL_HELP_CENTER = URL_HELP_CENTER;
var URL_LIFESTYLE_BEACHES = 'https://wagwalking.com/lifestyle/beaches';
exports.URL_LIFESTYLE_BEACHES = URL_LIFESTYLE_BEACHES;
var URL_LIFESTYLE_CAMPGROUNDS = 'https://wagwalking.com/lifestyle/campgrounds';
exports.URL_LIFESTYLE_CAMPGROUNDS = URL_LIFESTYLE_CAMPGROUNDS;
var URL_LIFESTYLE_PARKS = 'https://wagwalking.com/lifestyle/parks';
exports.URL_LIFESTYLE_PARKS = URL_LIFESTYLE_PARKS;
var URL_LIFESTYLE_TRAILS = 'https://wagwalking.com/lifestyle/trails';
exports.URL_LIFESTYLE_TRAILS = URL_LIFESTYLE_TRAILS;
var URL_NAMES = 'https://wagwalking.com/daily/names';
exports.URL_NAMES = URL_NAMES;
var URL_PARTNERS = 'https://wagwalking.com/partners';
exports.URL_PARTNERS = URL_PARTNERS;
var URL_PRESS_RELEASES = 'https://wagwalking.com/daily/press-releases';
exports.URL_PRESS_RELEASES = URL_PRESS_RELEASES;
var URL_PRIVACY_POLICY = 'https://wagwalking.com/privacy';
exports.URL_PRIVACY_POLICY = URL_PRIVACY_POLICY;
var URL_RESPONSIBLE_DISCLOSURE = 'https://wagwalking.com/responsible-disclosure';
exports.URL_RESPONSIBLE_DISCLOSURE = URL_RESPONSIBLE_DISCLOSURE;
var URL_SENSES = 'https://wagwalking.com/daily/senses';
exports.URL_SENSES = URL_SENSES;
var URL_SERVICE_DOG_BOARDING = 'https://wagwalking.com/dog-boarding';
exports.URL_SERVICE_DOG_BOARDING = URL_SERVICE_DOG_BOARDING;
var URL_SERVICE_DOG_DAYCARE = 'https://wagwalking.com/dog-daycare';
exports.URL_SERVICE_DOG_DAYCARE = URL_SERVICE_DOG_DAYCARE;
var URL_SERVICE_DOG_SITTING = 'https://wagwalking.com/dog-sitting';
exports.URL_SERVICE_DOG_SITTING = URL_SERVICE_DOG_SITTING;
var URL_SERVICE_DOG_WALKING = 'https://wagwalking.com/dog-walking';
exports.URL_SERVICE_DOG_WALKING = URL_SERVICE_DOG_WALKING;
var URL_TERMS_CONDITIONS = 'https://wagwalking.com/terms';
exports.URL_TERMS_CONDITIONS = URL_TERMS_CONDITIONS;
var URL_TRAINING = 'https://wagwalking.com/training';
exports.URL_TRAINING = URL_TRAINING;
var URL_TRUST_SAFETY = 'https://wagwalking.com/trust-safety';
exports.URL_TRUST_SAFETY = URL_TRUST_SAFETY;
var URL_WAG_TAG = 'https://tag.wagwalking.com';
exports.URL_WAG_TAG = URL_WAG_TAG;
var homeLinkData = {
  url: URL_HOME
};
exports.homeLinkData = homeLinkData;
var googlePlayLinkData = {
  url: URL_GOOGLE_PLAY_APP
};
exports.googlePlayLinkData = googlePlayLinkData;
var appStoreLinkData = {
  url: URL_APP_STORE_APP
};
exports.appStoreLinkData = appStoreLinkData;
var helpCenterLinkData = {
  url: URL_HELP_CENTER,
  label: 'Help Center'
};
exports.helpCenterLinkData = helpCenterLinkData;
var dailyWagLinkData = {
  url: URL_DAILY_WAG,
  label: 'Blog'
};
exports.dailyWagLinkData = dailyWagLinkData;
var becomeAWalkerLinkData = {
  url: URL_BECOME_WALKER,
  label: 'Become Wag! Walker'
};
exports.becomeAWalkerLinkData = becomeAWalkerLinkData;
var loginLinkData = {
  url: URL_APP_LOGIN,
  label: 'Log in'
};
exports.loginLinkData = loginLinkData;
var wagTagLinksData = {
  url: URL_WAG_TAG,
  label: 'Wag! Tag'
};
exports.wagTagLinksData = wagTagLinksData;
var aboutWagLinksData = [{
  url: URL_ABOUT,
  label: 'About Wag!'
}, {
  url: URL_TRUST_SAFETY,
  label: 'Trust and Safety'
}, {
  url: URL_COMMUNITY_GUIDELINES,
  label: 'Community guidelines'
}, {
  url: URL_PARTNERS,
  label: 'Wag! Partners'
}, {
  url: URL_PRESS_RELEASES,
  label: 'Press'
}, dailyWagLinkData, {
  url: URL_CAREERS,
  label: 'Careers'
}, becomeAWalkerLinkData];
exports.aboutWagLinksData = aboutWagLinksData;
var topWagCitiesLinksData = [{
  url: URL_DOG_WALKING_SAN_FRANCISCO,
  label: 'San Francisco'
}, {
  url: URL_DOG_WALKING_LOS_ANGELES,
  label: 'Los Angeles'
}, {
  url: URL_DOG_WALKING_CHICAGO,
  label: 'Chicago'
}, {
  url: URL_DOG_WALKING_NEW_YORK,
  label: 'New York'
}, {
  url: URL_DOG_WALKING_ATLANTA,
  label: 'Atlanta'
}, {
  url: URL_DOG_WALKING_WASHINGTON,
  label: 'Washington D.C.'
}, {
  url: URL_DOG_WALKING_DALLAS,
  label: 'Dallas'
}, {
  url: URL_DOG_WALKING_MIAMI,
  label: 'Miami'
}, {
  url: URL_DOG_WALKING_PHILADELPHIA,
  label: 'Philadelphia'
}, {
  url: URL_DOG_WALKING_ALL,
  label: 'All Walking Cities'
}, {
  url: URL_DOG_BOARDING_ALL,
  label: 'All Boarding Cities'
}];
exports.topWagCitiesLinksData = topWagCitiesLinksData;
var lifestyleLinksData = [{
  label: 'Dog Beaches',
  url: URL_LIFESTYLE_BEACHES
}, {
  label: 'Dog Campground',
  url: URL_LIFESTYLE_CAMPGROUNDS
}, {
  label: 'Dog Parks',
  url: URL_LIFESTYLE_PARKS
}, {
  label: 'Dog Trails',
  url: URL_LIFESTYLE_TRAILS
}];
exports.lifestyleLinksData = lifestyleLinksData;
var resourcesLinksData = [{
  label: 'Dog Health',
  url: URL_CARE
}, {
  label: 'Dog Training',
  url: URL_TRAINING
}, {
  label: 'Dog Grooming',
  url: URL_GROOMING
}, {
  label: 'Dog Breeds',
  url: URL_BREEDS
}, {
  label: 'Dog Names',
  url: URL_NAMES
}, {
  label: 'Dog Activities',
  url: URL_ACTIVITIES
}, {
  label: 'Dog Senses',
  url: URL_SENSES
}, {
  label: 'Dog Behavior',
  url: URL_BEHAVIOR
}];
exports.resourcesLinksData = resourcesLinksData;
var securityLinksData = [{
  label: 'Responsible disclosure',
  url: URL_RESPONSIBLE_DISCLOSURE
}];
exports.securityLinksData = securityLinksData;
var legalLinksData = [{
  label: 'Privacy policy',
  url: URL_PRIVACY_POLICY
}, {
  label: 'Terms & conditons',
  url: URL_TERMS_CONDITIONS
}];
exports.legalLinksData = legalLinksData;
var servicesLinksData = {
  key: 'services',
  url: '',
  label: 'Services',
  subRoutes: [{
    key: 'services/dog-walking',
    url: URL_SERVICE_DOG_WALKING,
    label: 'Wag! Walk'
  }, {
    key: 'services/dog-sitting',
    url: URL_SERVICE_DOG_SITTING,
    label: 'Sitting'
  }, {
    key: 'services/dog-boarding',
    url: URL_SERVICE_DOG_BOARDING,
    label: 'Boarding'
  }, {
    key: 'services/dog-daycare',
    url: URL_SERVICE_DOG_DAYCARE,
    label: 'Daycare'
  }]
};
exports.servicesLinksData = servicesLinksData;
var safetyLinksData = {
  key: 'safety',
  url: '',
  label: 'Safety',
  subRoutes: [{
    key: 'safety/community-guidelines',
    url: URL_COMMUNITY_GUIDELINES,
    label: 'Community Guidelines'
  }, {
    key: 'safety/trust-safety',
    url: URL_TRUST_SAFETY,
    label: 'Trust & Safety'
  }]
};
exports.safetyLinksData = safetyLinksData;